import { Component } from '@angular/core';

import { AlertService } from '../../_services/index';

@Component({
    selector: 'alert',
    templateUrl: 'alert.component.html',
    standalone: false
})

export class AlertComponent {
  message: any;

  constructor(private alertService: AlertService) { }

  ngOnInit() {
      this.alertService.getMessage().subscribe(message => { this.message = message; });
  }

  close(){
    this.message = undefined;
  }
}